<template>
	<div class="menu_left_box">
		<img src="../assets/logo.png" style="width: 100%;" />
		<div class="menulist_ban">
			
			<el-popover transition="el-zoom-in-center" placement="right" width="600" trigger="click">
				<div class="menulist_listbox">
					<div class="listmenu_findbox">
						<el-input size="mini" placeholder="请输入关键词搜索" v-model="input4">
							<el-button slot="append" icon="el-icon-search"></el-button>
						</el-input>
					</div>
					<div class="listmenu_listbox">
						<el-tabs tab-position="left">
							<el-tab-pane label="云零售">
								
								<div class="waterfall">
									<div class="box-card">
										<el-card shadow="hover">
											<div class="box-card-header">
												<span>销售管理</span>
											</div>
											<div class="menu_item">
												<span>菜单一</span>
												<i class="el-icon-star-off menu_item_icon"></i>
											</div>
											<div class="menu_item">
												<span>菜单二</span>
												<i class="el-icon-star-off menu_item_icon"></i>
											</div>
											<div class="menu_item">
												<span>菜单三</span>
												<i class="el-icon-star-off menu_item_icon"></i>
											</div>
											<div class="menu_item">
												<span>菜单四</span>
												<i class="el-icon-star-off menu_item_icon"></i>
											</div>
										</el-card>
									</div>
									
									<div class="box-card">
										<el-card shadow="hover">
											<div class="box-card-header">
												<span>职员管理</span>
											</div>
											<div v-for="o in 1" :key="o" class="menu_item">
												<span>{{'列表内容 ' + o }}</span>
												<i class="el-icon-star-off menu_item_icon"></i>
											</div>
										</el-card>
									</div>
									
									<div class="box-card">
										<el-card shadow="hover">
											<div class="box-card-header">
												<span>入库管理</span>
											</div>
											<div v-for="o in 3" :key="o" class="menu_item">
												<span>{{'列表内容 ' + o }}</span>
												<i class="el-icon-star-off menu_item_icon"></i>
											</div>
										</el-card>
									</div>
									
									<div class="box-card">
										<el-card shadow="hover">
											<div class="box-card-header">
												<span>入库管理</span>
											</div>
											<div v-for="o in 40" :key="o" class="menu_item">
												<span>{{'列表内容 ' + o }}</span>
												<i class="el-icon-star-off menu_item_icon"></i>
											</div>
										</el-card>
									</div>
									
								</div>
								
							</el-tab-pane>
							<el-tab-pane label="网订云系统">开发中...</el-tab-pane>
							<el-tab-pane label="运维系统">开发中...</el-tab-pane>
						</el-tabs>
					</div>
				</div>
				<el-button class="menulist_btn" icon="el-icon-menu" type="text" slot="reference">菜单列表 <i style="float: right;margin-right: 10px;" class="el-icon-arrow-right el-icon--right"></i></el-button>
			</el-popover>
			<div class="emnushoucang_list">
				<div class="menu_zilist" v-for="item in $store.state.menu_collection" :key="item.muid" @click="addTab(item.title,item.m_url)" >
					{{item.title}}
					<i class="el-icon-close menuicon"></i>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name:'menu_left',
		data() {
			return {
				input4:"",
			};
		},
		methods:{
			addTab(mtitle,murl) {
				let _this = this;
				_this.$store.state.iframe_loading = true;
				let newTabName = _this.$store.state.editableTab_index.toString();
				let mess = Math.random()*100;
				console.log(mess);
				_this.$store.state.editableTabs2.push({
					title: mtitle,
					name: newTabName,
					url: murl + mess
				});
				_this.$store.state.editableTabsValue2 = newTabName;
				_this.$store.state.moveboxshow = false;
				
				setTimeout(function(){
					// _this.$store.dispatch({
					// 	type:'getmenudata',
					// 	name:newTabName,
					// })
					// _this.getmenudata(newTabName);
					_this.$store.state.iframe_loading = false;
					_this.$store.state.editableTab_index++;
				},1000);
				
				
				
				
			},
			getmenudata:function(mdata){
				console.log("54545656565456",mdata);
				var freamid = 'iframepage'+ mdata
				console.log(freamid);
				console.log(document.getElementById(freamid));
				var iframe = document.getElementById(freamid).contentWindow;
				iframe.postMessage(localStorage.tnk,"*");
			}
		}
	}
</script>

<style scoped>
	.menu_left_box{
		width: 180px;
		height: 100%;
		position: absolute;
		left: 0;
		top: 0;
		z-index: 11;
		box-shadow: 0px 0px 5px #ccc;
		background-color: #fff;
		display: block;
	}
	.menulist_ban{
		width: 100%;
		height: calc(100% - 120px);
		/* height: 80%; */
		text-align: left;
		position: relative;
	}
	
	.menulist_listbox{
		width: 100%;
		padding: 15px 0px;
		/* min-height: 700px; */
		height: 700px;
		overflow-y: auto;
	}
	
	.menulist_btn{
		width: 100%;
		border-radius: 0px;
		height: 50px;
		transition: all .5s ease;
	}
	.menulist_btn:hover{
		background-color: #eee;
	}
	.emnushoucang_list{
		width: 100%;
		height: calc(100% - 50px);
		overflow-y: auto;
	}
	.menu_zilist{
		width: 100%;
		padding: 10px;
		text-align: center;
		cursor: pointer;
		color: #7d7d7d;
		position: relative;
		transition: all .3s ease;
	}
	.menu_zilist:hover{
		background-color: #eee;
		color: #409EFF;
	}
	.menu_zilist:hover > .menuicon{
		display: block;
	}
	.menuicon{
		float: right;
		display: none;
		position: absolute;
		top: 13px;
		right: 10px;
		transition: all .3s ease;
	}
	.menuicon:hover{
		transform: rotate(360deg);
	}
	
	.listmenu_findbox{
		width: 100%;
		padding-bottom: 10px;
		border-bottom: 1px solid #ccc;
		margin-bottom: 10px;
	}
	.listmenu_listbox{
		width: 100%;
		padding: 0px 10px;
	}
	
	/*瀑布流层*/
	.waterfall{
		width: 100%;
		padding-bottom: 10px;
		/* -moz-column-count:2;
		-webkit-column-count:2;
		column-count:2;
		-moz-column-gap: 10px;
		-webkit-column-gap: 10px;
		column-gap: 10px; */
	}
	
	.box-card{
		margin-bottom: 10px;
		/* -moz-page-break-inside: avoid;
		-webkit-column-break-inside: avoid;
		break-inside: avoid; */
		font-size: 14px;
	}
	.box-card-header{
		padding-bottom: 5px;
		border-bottom: 1px solid #eee;
		margin-bottom: 5px;
		font-weight: bold;
	}
	.menu_item{
		width: 49%;
		display: inline-block;
		padding: 5px;
		margin-bottom: 5px;
		color: #7d7d7d;
		cursor: pointer;
		position: relative;
		transition: all .3s ease;
	}
	.menu_item:hover{
		color: #409EFF;
		background-color: #EBEEF5;
	}
	.menu_item_icon{
		position: absolute;
		right: 10px;
		top: 8px;
		display: none;
		transition: all .3s ease;
	}
	.menu_item_icon:hover{
		transform: rotate(180deg);
	}
	.menu_item:hover > .menu_item_icon{
		display: block;
	}
</style>



// WEBPACK FOOTER //
// src/components/menu_left.vue